import { SitesType } from '@atlassiansox/asc-stargate';
import { ProductKey } from '@atlassiansox/bxpkit-core';
import { ProductPayloadType } from '../types';

/**
 * Build Devops products payload,
 * return the payload, plus existing products
 */

type BuildDevopsProductOptions = {
  readonly cloudName: string;
  readonly selectedSite?: SitesType;
  readonly breachStatus: boolean;
  readonly existingWorkspace?: boolean;
};

type BuildDevopsProductType = {
  productsNew: ProductPayloadType[];
  productsExisting: ProductKey[];
};

export function buildDevopsProduct({
  cloudName,
  selectedSite,
  breachStatus,
  existingWorkspace
}: BuildDevopsProductOptions): BuildDevopsProductType {
  const baseProductKeys = [
    ProductKey.JIRA_SOFTWARE,
    ProductKey.CONFLUENCE,
    ProductKey.BITBUCKET,
    ProductKey.OPSGENIE
  ];
  // set default for all-new products
  let productsExisting: ProductKey[] = [];
  let productsNew = baseProductKeys.map((productKey) => {
    if (
      breachStatus &&
      (productKey === ProductKey.JIRA_SOFTWARE ||
        productKey === ProductKey.CONFLUENCE)
    ) {
      return {
        accountName: cloudName,
        product: productKey,
        edition: 'standard'
      };
    }
    return {
      accountName: cloudName,
      product: productKey,
      edition: 'free'
    };
  });
  // if there is an existing workspace being used remove bitbucket from new
  if (existingWorkspace) {
    productsExisting.push(ProductKey.BITBUCKET);
    productsNew = productsNew.filter(
      ({ product }) => !productsExisting.includes(product)
    );
  }
  // no existing products
  if (!selectedSite || !selectedSite?.products) {
    return {
      productsNew,
      productsExisting
    };
  }

  // existing products
  productsExisting = selectedSite.products as ProductKey[];

  // JSM already includes OG (avoid provisioning OG if JSM is included)
  if (
    productsExisting.includes(ProductKey.JIRA_SERVICE_MANAGEMENT) &&
    !productsExisting.includes(ProductKey.OPSGENIE)
  ) {
    productsExisting.push(ProductKey.OPSGENIE);
  }

  // Avoid provisioning products that already exist
  productsNew = productsNew.filter(
    ({ product }) => !productsExisting.includes(product)
  );

  return {
    productsNew,
    productsExisting
  };
}
